function gst(state = {}, action) {
  switch (action.type) {
    case 'SET_GST_CART_DETAILS':
      const updatedGstCartDetails = { ...action.gstCartDetails };
      if (
        state?.gstCartDetails?.gstNumber &&
        state?.gstCartDetails?.gstNumber !== updatedGstCartDetails?.gstNumber
      ) {
        updatedGstCartDetails.isVerified = false;
      }
      console.log('🚀 gst reducer state update ', {
        gstCartDetails: {
          ...state.gstCartDetails,
          ...updatedGstCartDetails
        }
      });
      return {
        ...state,
        gstCartDetails: {
          ...state.gstCartDetails,
          ...updatedGstCartDetails
        }
      };
    case 'SET_GST_SAVED_PROFILES': {
      const newProfiles = action.gstSavedProfiles || [];
      const existingProfiles = state.gstProfiles || [];
      const existingOrder = state.initialGSTListOrder || [];
      if (existingOrder.length === 0 || newProfiles.length > existingProfiles.length) {
        return {
          ...state,
          gstProfiles: newProfiles,
          initialGSTListOrder: newProfiles.map(p => p.gstId)
        };
      }
      return { ...state, gstProfiles: newProfiles };
    }
    case 'SET_SELECTED_BILLING_ADDRESS':
      return {
        ...state,
        selectedBillingAddress: action.payload
      };
    default:
      return state;
  }
}

export default gst;
